import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { environment } from "../../environments/environment"
import { ApiService } from "./api.service"
import { LeadTimeType, StationOrderRule, UpdateStationOrderRulePayload } from "../models/order-rule.model"

/**
 * Station order start-date rules (minimum campaign start).
 * API paths must match API Gateway: GET/PUT /stations/{stationId}/order-rule
 */
@Injectable({
  providedIn: "root",
})
export class OrderRuleService {
  private readonly base = environment.apiUrl

  constructor(private api: ApiService) {}

  getStationOrderRule(stationId: number): Observable<StationOrderRule> {
    return this.api.get<StationOrderRule>(`${this.base}/stations/${stationId}/order-rule`)
  }

  updateStationOrderRule(stationId: number, payload: UpdateStationOrderRulePayload): Observable<StationOrderRule> {
    return this.api.put<StationOrderRule>(`${this.base}/stations/${stationId}/order-rule`, payload)
  }

  /**
   * Client-side preview only (browser-local calendar day).
   * Authoritative minimumStartDate comes from GET/PUT responses (server timezone).
   */
  previewMinimumStartDateLocal(leadTimeType: LeadTimeType, leadTimeValue: number): Date {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const n = Math.max(0, Math.floor(Number(leadTimeValue)) || 0)

    if (leadTimeType === "CALENDAR_DAYS") {
      const d = new Date(today)
      d.setDate(d.getDate() + n)
      return d
    }

    const d = new Date(today)
    let remaining = n
    while (remaining > 0) {
      d.setDate(d.getDate() + 1)
      const day = d.getDay()
      if (day !== 0 && day !== 6) {
        remaining -= 1
      }
    }
    return d
  }

  parseIsoDateLocal(iso: string): Date {
    const [y, m, day] = iso.split("-").map((x) => parseInt(x, 10))
    return new Date(y, (m || 1) - 1, day || 1)
  }
}
